import { useState } from 'react';
import './JoinUs.css';
import { FiSettings, FiExternalLink, FiChevronDown, FiX } from 'react-icons/fi';

const JoinUs = () => {
  const [activeBenefit, setActiveBenefit] = useState(0);
  const [showAllMembers, setShowAllMembers] = useState(false);
    const [showVideo, setShowVideo] = useState(false); 

  const benefits = [
    { 
      icon: '👁️‍🗨️', 
      title: 'VISIBILITY', 
      text: 'Join our growing community and put your club or initiative in front of more eyes than ever.',
      stats: 'Over 1000 Users'
    },
    { 
      icon: '🕸️', 
      title: 'Networking', 
      text: 'Create new partnerships, find fresh members, and spark unexpected collaborations—anything\'s possible here.',
      stats: '100+ Student Initiatives'
    },
    { 
      icon: '🚀', 
      title: 'Students ', 
      text: 'First access to local students actively seeking opportunities with organizations like yours',
      stats: 'Students eager to work with you'
    },
    { 
      icon: '🌍', 
      title: 'COMMUNITY INFLUENCE', 
      text: 'Position your organization as top leaders in CLTs growing business and nonprofit system',
      stats: <i><b> 'Have a chance to be featured in our weekly spotlight.'</b></i>
    }
  ];

  const coreMembers = [
    {
      id: 1,
      name: "Shivang Patel",
      role: "Founding Engineer",
      image: "/shivang.jpeg",
      featured: false,
      description: "future tony stark.",
      linkedin: "https://linkedin.com/in/shivang-patel-21753635a",
      github: "https://github.com/shaypat112",
      portfolio: "https://www.instagram.com/shivangpatll/"
    },
    {
      id: 2,
      name: "Sashvik",
      role: "Manager of Operations",
      image: "/sash.png",
      featured: false,
      description: "Hi, my name is Sashvik Devarapalli and I am a rising sophomore at Ballantyne Ridge. I love to play basketball with my friends!!",
      instagram: "https://www.instagram.com/sashvik_d/"
    },
    {
      id: 3,
      name: "Maria Avendano",
      role: "Networking Intern",
      image: "/sash.jpeg",
      featured: false,
      description: "Hi, I'm Maria! I recently joined the community outreach team as an intern. I go to Ardrey Kell and am excited to help grow this startup!",
      instagram: "https://www.instagram.com/maria_avendano08/"
    },
    {
      id: 4,
      name: "Saumyaa",
      role: "Community Outreach Lead",
      image: "/sam.jpeg",
      featured: false,
      description: "Hi, my name is Saumyaa Goyal. I am a sophomore at AKHS. I am so excited to work with the team as a communications lead!",
      instagram: "https://www.instagram.com/saumyaa.goyal/"
    },
    {
      id: 5,
      name: "Abhinav",
      role: "Social Services Intern",
      image: "/abhi.png",
      featured: false,
      description: "Hi, I am Abhinav. Proud to have recently joined CLT Student Hub. I am focused on building partnerships and growing together as one strong team family.",
      instagram: "https://www.instagram.com/abhinavramireddy/"
    },
    {
      id: 6,
      name: "Sharad Patel",
      role: "Resources Allocations Officer",
      image: "/shay.png",
      featured: false,
      description: " Excited to join CLT Student Hub as Resources Officer, managing all resources + investments to keep our startup sharp.",
      instagram: "https://www.instagram.com/lilshayypat/"
    },
    {
      id: 9,
      name: "Evan Wright",
      role: "Data Engineering Intern",
      image: "/even.png",
      featured: false,
      description: "N/A ",
      instagram: "https://www.linkedin.com/in/evan-wright-9b5961371/"
    },
    
  ];

  const additionalMembers = [
    {
      id: 7,
      name: "Nitin Rapolu",
      role: "Product Manager",
      image: "/nitin.png",
      featured: false,
      description: " Excited to join CLT Student Hub as Product Manager.",
      instagram: "https://www.instagram.com/nitinrapolu_1944"
    },
    {
      id: 8,
      name: "Advait Chandrakar",
      role: "Data Engineering Intern",
      image: "/advait.png",
      featured: false,
      description: " Excited to join CLT Student Hub.",
      instagram: "https://www.instagram.com/advaitc_304"
    },
    
  ];


  


  const toggleShowAllMembers = () => {
    setShowAllMembers(!showAllMembers);
  };
return (
  <div className="join-us-container">
    <div className="join-us-hero">
      <div className="hero-content fade-in">
        <h1>Queen City Student Initiatives</h1>
        <h2> Grow Your Initiative </h2>
        <div className="hero-divider"></div>
        <p className="subtitle">
          Join our Startup and partner with us today! Gain the connections that truly matter!
        </p>
        <button 
          className="cta-button"
          onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSdWY53ai41_c50AusSUYvlDHh2AtvQW3xhLSykuSmrDptXAeg/viewform?usp=header', '_blank')}
        >
          JOIN US
        </button>

        <button 
          className="teaser-button"
          onClick={() => setShowVideo(true)}
        >
          Teaser Trailer Video
        </button>
         <button 
          className="back-home-button"
          onClick={() => window.location.href = '/'
                  }        >
          Back to Home
        </button>
      </div>
    </div>

   
    {showVideo && (
      <div className="video-popup-overlay">
        <div className="video-popup-content">
          <button className="close-btn" onClick={() => setShowVideo(false)}>
            <FiX size={28} />
          </button>
          <video className="popup-video" controls autoPlay>
            <source src="/video.mp4" type="video/mp4" /> {/* placeholder video */}
            Your browser does not support the video tag.
          </video>
          <button className="skip-btn" onClick={() => setShowVideo(false)}>Skip</button>
        </div>
      </div>
    )}

    <section className="team-gallery-section">
      <div className="section-header slide-up">
        <h2>MEET OUR TEAM</h2>
        <p className="section-subtitle">The passionate individuals driving our community forward</p>
      </div>
      
      <div className="featured-member-card founder fade-in">
        <div className="featured-member-image">
          <img src={coreMembers[0].image} alt={coreMembers[0].name} />
          <div className="featured-badge">FOUNDER</div>
        </div>
        <div className="featured-member-info">
          <h3>{coreMembers[0].name}</h3>
          <p className="member-role">{coreMembers[0].role}</p>
          <p className="member-description">{coreMembers[0].description}</p>
          <div className="member-socials">
            {coreMembers[0].id === 1 ? (
              <>
                <a href={coreMembers[0].linkedin} target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
                <a href={coreMembers[0].github} target="_blank" rel="noopener noreferrer" className="social-link">GitHub</a>
                <a href={coreMembers[0].portfolio} target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
              </>
            ) : (
              <a href={coreMembers[0].instagram} target="_blank" rel="noopener noreferrer" className="social-link insta-btn">Instagram</a>
            )}
          </div>
        </div>
      </div>

      <div className="members-grid">
        {coreMembers.slice(1).map(member => (
          <div key={member.id} className="member-card fade-in">
            <div className="member-image">
              <img src={member.image} alt={member.name} />
            </div>
            <div className="member-info">
              <h4>{member.name}</h4>
              <p className="member-role">{member.role}</p>
              <p className="member-description">{member.description}</p>
              <div className="member-socials">
                <a href={member.instagram} target="_blank" rel="noopener noreferrer" className="social-link insta-btn">Instagram</a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="show-more-container">
        <button className="show-more-button" onClick={toggleShowAllMembers}>
          {showAllMembers ? (
            <>
              <FiX className="button-icon" /> SHOW LESS
            </>
          ) : (
            <>
              <FiChevronDown className="button-icon" /> MEET MORE TEAM MEMBERS
            </>
          )}
        </button>
      </div>

      {showAllMembers && (
        <div className="additional-members-section fade-in">
          <h3 className="additional-members-title">Join Our Team!</h3>
          <div className="members-grid">
            {additionalMembers.map(member => (
              <div key={member.id} className="member-card fade-in">
                <div className="member-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="member-info">
                  <h4>{member.name}</h4>
                  <p className="member-role">{member.role}</p>
                  <p className="member-description">{member.description}</p>
                  <div className="member-socials">
                    <a href={member.instagram} target="_blank" rel="noopener noreferrer" className="social-link insta-btn">Instagram</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>

    <section id="benefits" className="benefits-section">
      <div className="section-header">
        <h2> CONTENT BLANKS </h2>
        <p className="section-subtitle"><b> BLANK </b></p>
      </div>
      <div className="benefits-grid">
        {benefits.map((benefit, index) => (
          <div 
            key={index}
            className={`benefit-card fade-in ${activeBenefit === index ? 'active' : ''}`}
            onMouseEnter={() => setActiveBenefit(index)}
          >
            <div className="benefit-icon">{benefit.icon}</div>
            <h3>{benefit.title}</h3>
            <p>{benefit.text}</p>
            <div className="benefit-stats">{benefit.stats}</div>
          </div>
        ))}
      </div>
    </section>

    <section id="process" className="process-section">
      <div className="tech-stack-cta bw-theme fade-in">
        <div className="tech-stack-content">
          <h3 className="tech-stack-title">⚡ JOIN OUR TEAM</h3>
          <p className="tech-stack-text">
            Help us build and improve this Startup
          </p>
          <div className="tech-stack-guide">
            <div className="tech-stack-step-container">
              <span className="tech-stack-step">1</span>
              <p>Click the <FiSettings className="icon-inline"/> icon</p>
            </div>
            <div className="tech-stack-step-container">
              <span className="tech-stack-step">2</span>
              <p>Select <span className="tech-stack-highlight">Support</span></p>
            </div>
            <div className="tech-stack-step-container">
              <span className="tech-stack-step">3</span>
              <p>Email us your resume and qualifications</p>
            </div>
          </div>
          <a 
            href="https://www.linkedin.com/company/charlotte-student-hub/?viewAsMember=true" 
            target="_blank" 
            rel="noopener noreferrer"
            className="tech-stack-button"
          >
            GET STARTED <FiExternalLink className="icon-inline" />
          </a>
        </div>
      </div>
    </section>
     <section id="process" className="process-section">
      <div className="tech-stack-cta bw-theme fade-in">
        <div className="tech-stack-content">
          <h3 className="tech-stack-title"> Invest Now! </h3>
          <p className="tech-stack-text">
            Help us build and improve this Startup
          </p>
          <a 
            href="https://buy.stripe.com/9B6dRbej83n7fCsaL0enS03" 
            target="_blank" 
            rel="noopener noreferrer"
            className="tech-stack-button"
          >
            GET STARTED <FiExternalLink className="icon-inline" />
          </a>
        </div>
      </div>
    </section>
  </div>
);

};

export default JoinUs;
